import React, {useEffect, useState} from 'react'
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import DHDialog from "../../general/DHDialog";
import DHTextField from "../../general/DHTextField";
import DHSwitch from "../../general/DHSwitch";
import DHButtonSave from "../../general/DHButtonSave";

export default function VeranstalterRechnungseinstellungenDialog({eventOperatorId, onClose}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [name, setName] = useState("");
    const [strasse, setStrasse] = useState("");
    const [pLZ, setPLZ] = useState("");
    const [ort, setOrt] = useState("");
    const [email, setEmail] = useState("");

    const [automaticPayment, setAutomaticPayment] = useState(false);


    useEffect(() => {
        ladeRechnungsdaten();
    }, []);

    const ladeRechnungsdaten = () => {
        let url = ConfigUtil.getConfig().resourceUrls.eventoperator + "/rechnungsdaten/" + eventOperatorId;
        FetchUtil.fetchGet(url,
            json => {
                setName(json.rechnungName !== null ? json.rechnungName : "");
                setStrasse(json.rechnungStrasse !== null ? json.rechnungStrasse : "");
                setPLZ(json.rechnungPLZ !== null ? json.rechnungPLZ : "");
                setOrt(json.rechnungOrt !== null ? json.rechnungOrt : "");
                setEmail(json.rechnungEmail !== null ? json.rechnungEmail : "");
                setAutomaticPayment(json.rechnungAutomatisch);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden der Daten: " + responseNotOk.message)
            },
            error => {
                setErrorMessage("Fehler beim Laden der Daten: " + error.message)
            });
    }

    const save = () => {
        setErrorMessage(undefined);
        let data = {eventOperatorId: eventOperatorId,
            rechnungName: name,
            rechnungStrasse: strasse,
            rechnungPLZ: pLZ,
            rechnungOrt: ort,
            rechnungEmail: email,
            rechnungAutomatisch: automaticPayment,
        }
        let url = ConfigUtil.getConfig().resourceUrls.eventoperator + "/saverechnungsdaten"
        FetchUtil.fetchPost(url,
            data,
            (message) => {
                if (message !== null && message !== undefined && message !== "") {
                    setErrorMessage(message);
                } else {
                    setInfoMessage("Speichern erfolgreich");
                }
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }

    const getRechnungsadresse = () => {
        return <div>
            <div>
                Bitte Daten für Rechnung eintragen.
            </div>
            <div style={{marginTop: 20, fontSize:12, color:"red"}}>
                Achtung: Nur bei vollständig gefüllten Feldern ist eine Rechnungsausstellung oder PayPal möglich.
            </div>
            <div style={{marginTop: 10}}>
                <DHTextField id="id-rechnung-name"
                             label="Name Verein oder Veranstaltername oder dein persönlicher Name"
                             value={name} width={"100%"}
                             onChange={(text) => setName(text)}/>
            </div>
            <div style={{marginTop: 10}}>
                <DHTextField id="id-rechnung-strasse"
                             label="Straße" value={strasse}
                             width={"100%"}
                             onChange={(text) => setStrasse(text)}/>
            </div>
            <div className="grid" style={{marginTop: 10}}>
                <div className="col-fixed" style={{width: 200}}>
                    <DHTextField id="id-rechnung-plz"
                                 label="PLZ" value={pLZ}
                                 onChange={(text) => setPLZ(text)} width={"100%"}/>
                </div>
                <div className="col">
                    <DHTextField id="id-rechnung-ort" label="Ort" value={ort}
                                 onChange={(text) => setOrt(text)} width={"100%"}/>
                </div>
            </div>
            <div style={{marginTop: 10}}>
                <DHTextField id="id-email"
                             label="Email" value={email}
                             width={"100%"}
                             onChange={(text) => setEmail(text)}/>
            </div>
            <div style={{marginTop: 10}}>
                <DHSwitch id={"id-showMeetingkey"} label={"Automatische Rechnung 14 Tage bevor der Pro-Account ausläuft"} value={automaticPayment}
                          onChange={() => setAutomaticPayment(!automaticPayment)}/>
            </div>
            <div style={{marginTop: 10}}>
                <DHButtonSave disabled={false} label="Speichern" onClick={() => save()} working={false}/>
            </div>
        </div>
    }

    const closeDialog = () => {
        onClose();
    }

    return <DHDialog onClose={() => closeDialog()} title="Rechnungseinstellungen" show={true} buttons={[]} showCloseButton={true}
                     comp={<div style={{fontSize: 18}}>
                         <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage}
                                             onClearInfoMessage={() => setInfoMessage(undefined)}
                                             onClearErrorMessage={() => setErrorMessage(undefined)}/>
                         {getRechnungsadresse()}
                     </div>}/>
}
